import { useEffect, useState } from 'react';
import createApolloClient from '../../../api';
import getAllCategories from '../../../api/queries/posts/getAllCategories';
import getAllPosts from '../../../api/queries/posts/getAllPosts';
import sanitizeHTML from '../../../utils/sanitiseHTML';
import { convertDateToHuman } from '../../../utils/common/functions';

const client = createApolloClient();

const BlogListing = ({ section }) => {
  const [allCategory, setAllCategory] = useState([]);
  const [allBlog, setAllBlog] = useState([]);
  const [activeCategory, setActiveCategory] = useState(0);
  const [filteredBlog, setFilteredAllBlog] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const { data } = await client.query(getAllCategories());
      if (data?.categories?.nodes) {
        setAllCategory(data?.categories?.nodes);
      }
      const { data: blogData } = await client.query(getAllPosts());
      if (blogData?.posts?.nodes) {
        setAllBlog(blogData?.posts?.nodes);
        setFilteredAllBlog(blogData?.posts?.nodes);
      }
    };
    fetchData();
  }, []);
  return (
    <section className="section__blog">
      <div className="section__blog__banner">
        <div className="section__blog__banner__container">
          <div className="section__blog__banner__title">
            <h1>{section.sectionTitle}</h1>
            <p>{section.sectionDescription}</p>
          </div>
        </div>
      </div>
      <div className="section__blog__list">
        <div className="section__blog__list__container">
          {section.showCategoryFilter && (
            <div className="section__blog__list__filter-wrap">
              <div className="section__blog__list__filter-wrap__text">
                <label>Filter by category</label>
              </div>
              <div className="section__blog__list__filter-wrap__filter-list">
                <ul>
                  <li
                    className={`${activeCategory === 0 ? 'active' : ''}`}
                    onClick={() => {
                      setActiveCategory(0);
                      setFilteredAllBlog(allBlog);
                    }}
                  >
                    <span>All</span>
                  </li>
                  {allCategory.map((data, index) => {
                    return (
                      <li
                        className={`${activeCategory === data.termTaxonomyId ? 'active' : ''}`}
                        key={index}
                        onClick={() => {
                          const filteredPosts = allBlog.filter((post) => {
                            return post.categories.nodes.some(
                              (category) => category.termTaxonomyId === data.termTaxonomyId,
                            );
                          });
                          setActiveCategory(data.termTaxonomyId);
                          setFilteredAllBlog(filteredPosts);
                        }}
                      >
                        <span>{data.name}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          <div className="section__blog__item__list">
            {filteredBlog.map((data, index) => {
              return (
                <a key={index} href={`/blog/${data.slug}`} className="section__blog__item">
                  {data?.featuredImage?.node?.sourceUrl && (
                    <div className="section__blog__item__img-wrap">
                      <img
                        src={data?.featuredImage?.node?.sourceUrl}
                        width={400}
                        height={210}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="section__blog__item__content-wrap">
                    {data?.categories?.nodes && (
                      <div className="section__blog__item__tag-wrap">
                        {data?.categories?.nodes.map((data, index) => {
                          return (
                            <label className="section__blog__item__tag blog__tag">
                              {data?.name}
                            </label>
                          );
                        })}
                      </div>
                    )}
                    {data?.title && (
                      // <Link href={`/blog/${data?.slug}`}>
                      <h6 className="section__blog__item__title">{data?.title}</h6>
                      // </Link>
                    )}
                    <label className="section__blog__item__date blog__date">
                      {data?.author?.node?.name && `By ${data?.author?.node?.name}`}
                      {data?.date && ` / ${convertDateToHuman(data?.date)}`}
                    </label>
                    {data?.excerpt && (
                      <p
                        className="section__blog__item__desc blog__desc"
                        dangerouslySetInnerHTML={{ __html: sanitizeHTML(data?.excerpt) }}
                      />
                    )}
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogListing;
